module.exports = __webpack_public_path__ + "static/media/header-wallet-walletconnect.5d946827.svg";